<!-- AG一般ユーザー登録・変更 登録画面 -->
<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-else class="com_form_contet_admin">
    <section class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">
          <template v-if="isUpdateMode">ユーザー編集</template>
          <template v-else>ユーザー登録</template>
        </h2>
      </div>
      <!-- エラーメッセージの表示エリア -->
      <div
        v-if="errorMessage"
        class="error-message"
        style="white-space: pre-wrap"
      >
        {{ errorMessage }}
      </div>

      <table style="width: 70%">
        <thead>
          <th style="width: 5%"></th>
          <th style="width: 30%"></th>
          <th style="width: 65%"></th>
        </thead>
        <tbody>
          <tr>
            <td class="required-mark"></td>
            <td class="form-control-title">エージェントコード</td>
            <td>
              <label class="form-control">{{ agName }}</label>
            </td>
          </tr>
          <tr>
            <td class="required-mark">※</td>
            <td class="form-control-title">会社名</td>
            <td>
              <input
                id="kaisyaName"
                v-model="agUserData.kaisyaName"
                type="text"
                placeholder="会社名"
                maxlength="255"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <td class="required-mark">※</td>
            <td class="form-control-title">部署名</td>
            <td>
              <input
                id="busyoName"
                v-model="agUserData.busyoName"
                type="text"
                placeholder="部署名"
                maxlength="255"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <td class="required-mark">※</td>
            <td class="form-control-title">担当者名</td>
            <td>
              <input
                id="tantousyaName"
                v-model="agUserData.tantousyaName"
                type="text"
                placeholder="担当者名"
                maxlength="255"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <td class="required-mark">※</td>
            <td class="form-control-title">メールアドレス</td>
            <td>
              <input
                id="email"
                v-model="agUserData.email"
                type="text"
                placeholder="メールアドレス"
                maxlength="255"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <td class="required-mark"></td>
            <td class="form-control-title">備考１</td>
            <td>
              <input
                id="bikou1"
                v-model="agUserData.bikou1"
                type="text"
                placeholder="備考１"
                maxlength="255"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <td class="required-mark"></td>
            <td class="form-control-title">備考２</td>
            <td>
              <input
                id="bikou2"
                v-model="agUserData.bikou2"
                type="text"
                placeholder="備考２"
                maxlength="255"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <td class="required-mark">※</td>
            <td class="form-control-title">機能権限</td>
            <td>
              <select
                id="roleId"
                v-model="agUserData.roleId"
                class="form-control"
              >
                <option></option>
                <option
                  v-for="item in kinouKengenList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.text }}
                </option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>

      <br />
      <div class="form-inline flex-container" style="width: 70%">
        <button
          type="button"
          name="btnBack"
          class="btn btn-footer btn-primary"
          @click="onBack"
        >
          戻る
        </button>

        <button
          type="button"
          name="btnClear"
          class="btn btn-footer btn-primary"
          @click="onClear"
        >
          クリア
        </button>

        <button
          type="button"
          name="btnFixed"
          class="btn btn-footer btn-primary"
          @click="onFixed"
        >
          確定
        </button>
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
</template>
<script lang="ts">
import { defineComponent, computed, onMounted, ref } from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import { useRouter } from "vue-router";
import { useUserParmitionStore } from "@/store/userParmitionStore";
import { useProcessingStore } from "../../store/useProcessingStore";
import apiAuthClient from "@/util/apiClientAuth";
import { AppConstants } from "@/constants/AppConstants";
import {
  formatMessage,
  sanitizeInput,
  hasNoGaiji,
  isTokenAlive,
  commonHandleAxiosError,
} from "@/Common";
import messages from "@/assets/messages.json";
import { useUserStore } from "@/store/userStore";

interface aguserRegParam {
  agCode: string;
  userId: string;
  processingMode: string;
}

interface selectItem {
  value: string;
  text: string;
}

interface agUserData {
  agCode: string;
  userId: string;
  kaisyaName: string;
  busyoName: string;
  tantousyaName: string;
  email: string;
  bikou1: string;
  bikou2: string;
  roleId: string;
}

export default defineComponent({
  name: "AgUserMaintenanceComponent",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  setup() {
    const router = useRouter();
    const { getCategoryIdByName } = useUserParmitionStore();
    const processingStore = useProcessingStore();
    const errorMessage = ref("");
    const agCode = ref(""); // ローカルストレージのAGコード
    const userId = ref(""); // ローカルストレージのユーザーID
    const kaisyaName = ref(""); // ローカルストレージの会社名
    const categoryId = ref<string | null>(null);
    const isKaunetAdmin = ref(false);
    const paramAgCode = ref(""); // パラメータのAGコード
    const paramUserId = ref(""); // パラメータのユーザーID
    const processingMode = ref(""); // パラメータの処理モード
    const kinouKengenList = ref<selectItem[]>([]);
    const agName = ref("");
    const agUserData = ref<agUserData>({
      agCode: "",
      userId: "",
      kaisyaName: "",
      busyoName: "",
      tantousyaName: "",
      email: "",
      bikou1: "",
      bikou2: "",
      roleId: "",
    });
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const { logoutUser } = useUserStore();

    // 初期処理
    onMounted(async () => {
      // ローカルストレージからユーザー情報を取得して内部変数に展開
      const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
      if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);
        agCode.value = parsedUserInfo.agCode;
        userId.value = parsedUserInfo.userId;
        kaisyaName.value = parsedUserInfo.companyName;
        isKaunetAdmin.value = parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;
      }
      // カテゴリID取得
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_AG_USER_TOUROKU
      );

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // sessionStorageからパラメータ取得
        const sessionParam = sessionStorage.getItem(
          AppConstants.AGUSER_REG_SESSION_NAME
        );
        if (sessionParam) {
          // 存在する場合はパラメータを変数にセット
          const aguserRegParam = JSON.parse(sessionParam) as aguserRegParam;
          paramAgCode.value = aguserRegParam.agCode;
          paramUserId.value = aguserRegParam.userId;
          processingMode.value = aguserRegParam.processingMode;

          // sessionStorageからパラメータ削除
          sessionStorage.removeItem(AppConstants.AGUSER_REG_SESSION_NAME);
        } else {
          // 存在しない場合はエラー
          errorMessage.value = messages.ERR_SYS998;
          return;
        }

        // パラメータチェック
        if (!isKaunetAdmin.value) {
          // パラメータのAGコードとローカルストレージのAGコードが異なる場合
          if (paramAgCode.value != agCode.value) {
            errorMessage.value = messages.ERR_SYS998;
            return;
          }
        }

        // 機能権限リスト取得
        const response = await apiAuthClient.post(
          "/api/AgUser/getKinouKengenList",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            agCode: agCode.value,
            userId: userId.value,
            categoryId: categoryId.value,
            displayAgCode: paramAgCode.value,
          }
        );

        // エージェントコード名称設定
        agName.value = response.data.agName;
        // 機能権限コンボボックス設定
        kinouKengenList.value = response.data.kinouKengenList;

        if (isUpdateMode.value) {
          // 更新モードの場合

          // AG一般ユーザー情報取得
          await getAgUser();
        } else {
          // 新規登録モードの場合

          // 画面．エージェントコード設定
          agUserData.value.agCode = paramAgCode.value;
          // 画面．会社名設定
          agUserData.value.kaisyaName = kaisyaName.value;
        }
        // 初期表示エラーフラグをOFF
        isInitError.value = false;
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    });

    /**
     * 戻るボタン押下
     */
    const onBack = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      const isConfirm = window.confirm(formatMessage(messages.CNF_0002));
      if (!isConfirm) {
        // いいえの場合
        return;
      }
      // AG一般ユーザー登録・変更 一覧画面へ遷移
      router.push({
        path: "/aguser-maintenance",
        query: {
          isResearch: "true",
        },
      });
    };

    /**
     * クリアボタン押下
     */
    const onClear = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // トークン有効性チェック
      if ((await isTokenAlive()) == false) {
        // トークンが無効な場合はログイン画面へ
        logoutUser();
        alert(messages.ERR_USER001);
        router.push("/login");
        return;
      }

      // 確認ダイアログ表示
      const isConfirm = window.confirm(formatMessage(messages.CNF_0002));
      if (!isConfirm) {
        // いいえの場合
        return;
      }

      // メッセージクリア
      errorMessage.value = "";

      if (isUpdateMode.value) {
        // 処理中フラグON
        processingStore.isProcessing = true;

        try {
          // AG一般ユーザー情報取得
          await getAgUser();
        } catch (error: unknown) {
          // エラー処理
          handleAxiosError(error);
        } finally {
          // 処理中フラグOFF
          processingStore.isProcessing = false;
        }
      } else {
        // 新規登録モードの場合
        agUserData.value = {
          agCode: paramAgCode.value,
          userId: "",
          kaisyaName: kaisyaName.value,
          busyoName: "",
          tantousyaName: "",
          email: "",
          bikou1: "",
          bikou2: "",
          roleId: "",
        };
      }
    };

    /**
     * AG一般ユーザー情報取得
     */
    const getAgUser = async () => {
      const response = await apiAuthClient.post("/api/AgUser/getAgUser", {
        systemKbn: process.env.VUE_APP_SYSTEM_KBN,
        agCode: agCode.value,
        userId: userId.value,
        categoryId: categoryId.value,
        agUserData: {
          agCode: paramAgCode.value,
          userId: paramUserId.value,
        },
      });

      // レスポンスを保持
      agUserData.value = response.data.agUserData;
    };

    /**
     * 確定ボタン押下
     */
    const onFixed = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // メッセージクリア
      errorMessage.value = "";

      // 入力チェック
      // メールアドレスチェック
      if (!validateInput() || !validateEmail()) {
        return;
      }

      const processingName = isUpdateMode.value ? "更新" : "登録";
      const apiUrl = isUpdateMode.value
        ? "/api/AgUser/updateAgUser"
        : "/api/AgUser/createAgUser";

      // 確認ダイアログ表示
      const isConfirm = window.confirm(
        formatMessage(messages.CNF_0001, "ユーザー", processingName)
      );
      if (!isConfirm) {
        // いいえの場合
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      // トークン有効性チェック
      if ((await isTokenAlive()) == false) {
        // トークンが無効な場合はログイン画面へ
        logoutUser();
        alert(messages.ERR_USER001);
        router.push("/login");
        return;
      }

      try {
        await apiAuthClient.post(apiUrl, {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          agCode: agCode.value,
          userId: userId.value,
          categoryId: categoryId.value,
          // agUserData: agUserData.value,
          agUserData: {
            agCode: agUserData.value.agCode,
            userId: agUserData.value.userId,
            kaisyaName: sanitizeInput(agUserData.value.kaisyaName),
            busyoName: sanitizeInput(agUserData.value.busyoName),
            tantousyaName: sanitizeInput(agUserData.value.tantousyaName),
            email: sanitizeInput(agUserData.value.email),
            bikou1: sanitizeInput(agUserData.value.bikou1),
            bikou2: sanitizeInput(agUserData.value.bikou2),
            roleId: agUserData.value.roleId,
          },
        });

        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "ユーザー", processingName));

        // AG一般ユーザー登録・変更 一覧画面へ遷移
        router.push({
          path: "/aguser-maintenance",
          query: {
            isResearch: "true",
          },
        });
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 入力チェック
     */
    const validateInput = (): boolean => {
      // サニタイジング
      const sanitizedKaisyaName = sanitizeInput(agUserData.value.kaisyaName);
      const sanitizedBusyoName = sanitizeInput(agUserData.value.busyoName);
      const sanitizedTantousyaName = sanitizeInput(
        agUserData.value.tantousyaName
      );
      const sanitizedEmail = sanitizeInput(agUserData.value.email);
      const sanitizedBikou1 = sanitizeInput(agUserData.value.bikou1);
      const sanitizedBikou2 = sanitizeInput(agUserData.value.bikou2);

      const messageList = ref<string[]>([]);

      // 会社名
      // 必須チエック、使用不可文字チェック
      if (!sanitizedKaisyaName) {
        messageList.value.push(formatMessage(messages.ERR_0001, "会社名"));
      } else if (!hasNoGaiji(sanitizedKaisyaName)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "会社名"));
      }

      // 部署名
      // 必須チエック、使用不可文字チェック
      if (!sanitizedBusyoName) {
        messageList.value.push(formatMessage(messages.ERR_0001, "部署名"));
      } else if (!hasNoGaiji(sanitizedBusyoName)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "部署名"));
      }

      // 担当者名
      // 必須チエック、使用不可文字チェック
      if (!sanitizedTantousyaName) {
        messageList.value.push(formatMessage(messages.ERR_0001, "担当者名"));
      } else if (!hasNoGaiji(sanitizedTantousyaName)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "担当者名"));
      }

      // メールアドレス
      // 必須チエック、使用不可文字チェック
      if (!sanitizedEmail) {
        messageList.value.push(
          formatMessage(messages.ERR_0001, "メールアドレス")
        );
      } else if (!hasNoGaiji(sanitizedEmail)) {
        messageList.value.push(
          formatMessage(messages.ERR_0026, "メールアドレス")
        );
      }

      // 備考１
      // 使用不可文字チェック
      if (!hasNoGaiji(sanitizedBikou1)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "備考１"));
      }

      // 備考２
      // 使用不可文字チェック
      if (!hasNoGaiji(sanitizedBikou2)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "備考２"));
      }

      // 機能権限
      // 必須チェック
      if (!agUserData.value.roleId) {
        messageList.value.push(formatMessage(messages.ERR_0003, "機能権限"));
      }

      // エラーがある場合
      if (messageList.value.length > 0) {
        messageList.value.forEach((message, index) => {
          if (index > 0) {
            errorMessage.value += String.fromCharCode(10);
          }
          errorMessage.value += message;
        });
        return false;
      } else {
        errorMessage.value = "";
        return true;
      }
    };

    /**
     * メールアドレスチェック
     */
    const validateEmail = (): boolean => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isHalfWidth = /^[\x20-\x7E]+$/;
      const sanitizedEmail = sanitizeInput(agUserData.value.email);

      if (!isHalfWidth.test(sanitizedEmail)) {
        errorMessage.value = formatMessage(messages.ERR_0018, "メールアドレス");
        return false;
      } else if (!emailPattern.test(sanitizedEmail)) {
        errorMessage.value = formatMessage(messages.ERR_0020, "メールアドレス");
        return false;
      } else {
        errorMessage.value = "";
        return true;
      }
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, false);
    };

    /**
     * 更新モード判定
     */
    const isUpdateMode = computed(() => {
      return processingMode.value == AppConstants.AG_USER_EDIT_MODE_UPDATE;
    });

    return {
      errorMessage,
      router,
      kinouKengenList,
      agName,
      agUserData,
      isUpdateMode,
      onBack,
      onClear,
      onFixed,
      isInitError,
    };
  },
});
</script>

<style scoped>
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
.form-control-title {
  text-align: center;
  background-color: lightgrey;
  border-radius: 0.25rem;
}
select.form-control {
  -webkit-appearance: auto;
  appearance: auto;
}
.flex-container {
  display: flex;
  justify-content: flex-end;
}
.btn {
  margin: 0.25rem 0.125rem;
}
.btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 140px;
}
table {
  border-collapse: separate;
}
</style>
